import { IoStarSharp } from 'react-icons/io5'
import { useIntl } from 'react-intl'

const relations = {
	boss: { es: 'Mi Jefe ', pt: 'Meu Chefe' },
	pairs: { es: 'Par ', pt: 'Par' },
	team: { es: 'Mi Equipo', pt: 'Minha Equipe' },
	other_team: { es: 'Otro Equipo,', pt: 'Outra Equipe,' },
}

export function FeedbackCard({ feedback, type }) {
	const { name } = JSON.parse(localStorage.getItem('user'))
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	return (
		<div className='tw-bg-white tw-shadow-sm tw-rounded-lg tw-p-6 tw-border border'>
			<div className='tw-flex tw-justify-between tw-items-center tw-mb-2'>
				{type === 'received' && (
					<div className='tw-flex tw-items-center tw-gap-2'>
						<h5 className='tw-m-0 tw-p-0 tw-text-base tw-text-black tw-font-bold'>{feedback.from.name}</h5>
						<h5 className='tw-m-0 tw-text-base tw-text-black tw-px-2 tw-py-1 tw-bg-gray-100 tw-rounded-md'>
							{relations[feedback.relation][language]}
						</h5>
					</div>
				)}
				<div className='tw-flex tw-items-center tw-gap-2 tw-mb-4'>
					<span className='tw-font-semibold tw-text-gray-800 tw-text-sm'>Evaluación</span>
					<div className='tw-flex tw-items-center'>
						<div className='tw-flex'>
							{[1, 2, 3, 4, 5].map(item => (
								<IoStarSharp key={item} className={`${feedback.rating >= item ? 'tw-text-[#FBBF23]' : 'tw-text-gray-200'}`} />
							))}
						</div>
						<span className='tw-ml-2 tw-text-gray-800 tw-font-semibold tw-text-sm'>{feedback.rating}</span>
					</div>
				</div>
			</div>
			<p className='tw-text-gray-600 tw-text-sm tw-mb-4'>{feedback.comment}</p>
			<span className='tw-text-gray-500 tw-text-xs'>{feedback.createdAt.split('T')[0]}</span>
		</div>
	)
}
